import React, { useState, useEffect } from "react";
import { AuthMe } from "../lib/MyHttp";
import { Update, Delete } from "../lib/User";
import { useTranslation } from "react-i18next";
import { typeSex, calculateAge } from "../lib/Common";
import moment from "moment";
import DaumAddressSearch from "../components/DaumAddressSearch";

const years = [];
const month = [];
const days = [];
const nowYYYY = moment().format("YYYY");

for (let i = 1900; i <= nowYYYY; i++) years.push(i);
for (let i = 1; i <= 12; i++) month.push(i);
for (let i = 1; i <= 31; i++) days.push(i);

const ModifyMember = () => {
    const { t } = useTranslation();

    useEffect(() => {}, []);

    const [data, setData] = useState({});

    useEffect(() => {
        AuthMe(res => {
            res.phone1 = res.phone.substring(0, 3);
            res.phone2 = res.phone.substring(3, 7);
            res.phone3 = res.phone.substring(7, 11);
            if (res.birth.length !== 10) {
                res.birth = "1950-01-01";
            }
            setData(res);
        });
    }, []);

    const clickSave = () => {
        if (data.pwd1) {
            if (data.pwd1 !== data.pwd2) {
                alert(t("패스워드를 확인해주세요."));
                return;
            }
            data.pw = data.pwd1;
        }
        Update(data, res => {
            alert(t("저장을 완료 하였습니다."));
        });
    };

    const clickDelete = () => {
        if (window.confirm(t("탈퇴 하시겠습니까?"))) {
            Delete([data.member_no], res => {
                localStorage.setItem("access_token", "");
                localStorage.setItem("refresh_token", "");
                localStorage.setItem("token_type", "");
                localStorage.setItem("expires_in", "");
                window.location = "/";
            });
        }
    };

    return (
        <main className="sub-contents">
            <section className="sub-top-section"></section>

            <div className="inner">
                <h2 className="sub_title">{t("회원 정보 수정")} </h2>
                <h3 className="sub_title_sm">Modify Member</h3>

                <div className="table_box">
                    <table className="tbl_join small">
                        <caption>{t("회원정보수정")}</caption>
                        <colgroup>
                            <col width="30%" />
                            <col width="70%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    <label htmlFor="modify_name">{t("이름")}</label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="text"
                                            className="text_nor md"
                                            id="modify_name"
                                            placeholder={t("이름을 입력해주세요")}
                                            value={data.name}
                                            onChange={e => {
                                                data.name = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="modify_email">{t("이메일")}</label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="text"
                                            className="text_nor md"
                                            id="modify_email"
                                            placeholder={t("이메일을 입력해주세요")}
                                            value={data.email}
                                            onChange={e => {
                                                data.email = e.target.value;
                                                setData({ ...data });
                                            }}
                                            disabled={true}
                                        />
                                        {/* <button type="button" className="btn_nor md line">
                                            {t("중복확인")}
                                        </button> */}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="modify_pwd">{t("비밀번호")}</label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="password"
                                            className="text_nor md w100"
                                            id="modify_pwd"
                                            placeholder={t("비밀번호를 입력해주세요")}
                                            value={data.pwd1}
                                            onChange={e => {
                                                data.pwd1 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <input
                                            type="password"
                                            className="text_nor md w100"
                                            id="modify_pwd"
                                            placeholder={t("비밀번호를 다시 한번 입력해주세요")}
                                            value={data.pwd2}
                                            onChange={e => {
                                                data.pwd2 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>{t("휴대전화 번호")}</label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="number"
                                            className="text_nor md phone"
                                            maxLength={4}
                                            value={data.phone1}
                                            onChange={e => {
                                                data.phone1 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <span>-</span>
                                        <input
                                            type="number"
                                            className="text_nor md phone"
                                            maxLength={4}
                                            value={data.phone2}
                                            onChange={e => {
                                                data.phone2 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <span>-</span>
                                        <input
                                            type="number"
                                            className="text_nor md phone"
                                            maxLength={4}
                                            value={data.phone3}
                                            onChange={e => {
                                                data.phone3 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="modify_birth">{t("생년월일")}</label>
                                </th>
                                <td>
                                    <div className="form-box birth">
                                        <select
                                            className="select_nor md"
                                            value={moment(data.birth).format("YYYY")}
                                            onChange={e => {
                                                data.birth = moment(data.birth).set("year", e.target.value).format("YYYY-MM-DD");
                                                setData({ ...data });
                                            }}
                                        >
                                            {years.map(x => (
                                                <option value={x}>{x}</option>
                                            ))}
                                        </select>
                                        <span>{t("년")} </span>
                                        <select
                                            className="select_nor md"
                                            value={moment(data.birth).format("M")}
                                            onChange={e => {
                                                data.birth = moment(data.birth)
                                                    .set("month", e.target.value - 1)
                                                    .format("YYYY-MM-DD");
                                                setData({ ...data });
                                            }}
                                        >
                                            {month.map(x => (
                                                <option value={x}>{x}</option>
                                            ))}
                                        </select>
                                        <span>{t("월")} </span>
                                        <select
                                            className="select_nor md"
                                            value={moment(data.birth).format("D")}
                                            onChange={e => {
                                                data.birth = moment(data.birth).set("date", e.target.value).format("YYYY-MM-DD");
                                                setData({ ...data });
                                            }}
                                        >
                                            {days.map(x => (
                                                <option value={x}>{x}</option>
                                            ))}
                                        </select>
                                        <span>{t("일")} </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="modify_addr">{t("주소")}</label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="text"
                                            className="text_nor md"
                                            id="modify_addr"
                                            value={data.addr1}
                                            onChange={e => {
                                                data.addr1 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        {/* <button type="button" className="btn_nor md line">
                                            우편번호
                                        </button> */}
                                        <DaumAddressSearch
                                            onSelect={addr => {
                                                data.zipcode = addr.zonecode;
                                                data.addr1 = addr.address;
                                                setData({ ...data });
                                            }}
                                            className="mobile_gnb"
                                        />
                                    </div>
                                    <div className="form-box">
                                        {/* <input
                                            type="text"
                                            className="text_nor md w100"
                                            value={data.addr1}
                                            onChange={e => {
                                                data.addr1 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        /> */}
                                        <input
                                            type="text"
                                            className="text_nor md w100"
                                            placeholder={t("상세주소를 입력하세요")}
                                            value={data.addr2}
                                            onChange={e => {
                                                data.addr2 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="modify_disease">
                                        {t("병력")}/{t("질환")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="text"
                                            className="text_nor md"
                                            id="modify_disease"
                                            placeholder={t("질병을 입력하세요.")}
                                            value={data.medical}
                                            onChange={e => {
                                                data.medical = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        {/* <button type="button" className="btn_nor md line">
                                            검색
                                        </button> */}
                                    </div>
                                    {/* <div className="form-box">
                                        <input type="text" className="text_nor md w100" />
                                        <input type="text" className="text_nor md w100" />
                                    </div> */}
                                </td>
                            </tr>
                            {/* <tr>
                                <th>
                                    <label htmlFor="modify_hospital">병원 연동</label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input type="text" className="text_nor md" id="modify_hospital" placeholder="병원을 검색 하세요" />
                                        <button type="button" className="btn_nor md line">
                                            검색
                                        </button>
                                    </div>
                                </td>
                            </tr> */}
                        </tbody>
                    </table>
                </div>

                <div className="btn_bott_box">
                    <a href="/" className="btn_nor line minW">
                        {t("돌아가기")}
                    </a>
                    <a href="javascript:;" className="btn_nor orange minW" onClick={clickSave}>
                        {t("수정하기")}
                    </a>
                    <a href="javascript:;" className="btn_nor gray minW" onClick={clickDelete}>
                        {t("탈퇴하기")}
                    </a>
                </div>
            </div>
        </main>
    );
};

export default ModifyMember;
